import * as yup from "yup";

export const visitorPurposeSchema = yup.object({
  purpose_name: yup
    .string()
    .trim()
    .required("Purpose name is required"),
  status_id: yup
    .string()
    .oneOf(["1", "2"], "Select Active or Inactive")
    .required("Status is required"),
});

export const visitorPurposeFormDefaults = {
  purpose_name: "",
  status_id: "1",
};
